
/* injects from baggage-loader */

import AlertModule from './alert/alert.module';
import ConfirmModule from './confirm/confirm.module';
import ConfirmAvatarModule from './confirm-avatar/confirm-avatar.module';
import DialogModule from './dialog/dialog.module';
import DialogTutorialModule from './tutorial/tutorial.module';
import DialogInterventionalModule from './interventional/interventional.module';
import DialogIntroModule from './intro/intro.module';
import DialogRegionModule from './region/region.module';
import FeedbackModule from './feedback/feedback.module';
import DialogTrophyModule from './trophy/trophy.module';

const shared = angular.module('dialog-module', [
  AlertModule.name,
  ConfirmModule.name,
  ConfirmAvatarModule.name,
  DialogModule.name,
  DialogTutorialModule.name,
  DialogInterventionalModule.name,
  DialogIntroModule.name,
  DialogRegionModule.name,
  FeedbackModule.name,
  DialogTrophyModule.name
]);

export default shared;


// WEBPACK FOOTER //
// ./src/app/components/dialogs/dialogs.module.js